const hiddenButtons = document.querySelectorAll('.hiddenText-button');

// Pour chaque bouton, ajoute un écouteur de clic
hiddenButtons.forEach(function(hiddenButton) {
  hiddenButton.addEventListener('click', function () {
    const parent = this.parentElement;
    parent.classList.toggle('closed');
    hiddenButton.querySelector('.more').classList.toggle('hidden');
    hiddenButton.querySelector('.less').classList.toggle('hidden');
  });
});